import * as React from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 48 49", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M24 .5C10.745.5 0 11.245 0 24.5s10.745 24 24 24 24-10.745 24-24S37.255.5 24 .5m1.224 22.823H30.4v2.354h-5.176V30.9h-2.448v-5.223H17.6v-2.354h5.176V18.1h2.448z", clipRule: "evenodd" }));
export default SvgAdd;
